import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PLAY_NEXT } from '../../actions/Playback';
export default function NextButton(props) {
    var _a, _b, _c;
    useEffect(() => { var _a, _b; return (_b = (_a = navigator) === null || _a === void 0 ? void 0 : _a.mediaSession) === null || _b === void 0 ? void 0 : _b.setActionHandler('nexttrack', triggerNext); }, []);
    const dispatch = useDispatch();
    const { next } = useSelector((state) => state.PlaybackStates);
    const { mediaId } = useSelector((state) => state.Media);
    const triggerNext = () => dispatch({ type: PLAY_NEXT, payload: { mediaId } });
    if (!next) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { "aria-label": (_a = next) === null || _a === void 0 ? void 0 : _a.description, disabled: false, className: ((_b = next) === null || _b === void 0 ? void 0 : _b.isDisabled) ? 'disabled hydrated sc-music-button-h' : 'hydrated sc-music-button-h', onmusicActivate: triggerNext, variant: "primary", "icon-name": "next", "icon-only": true, size: props.size || 'small' }, (_c = next) === null || _c === void 0 ? void 0 : _c.description));
}
;
